export const DESKTOP_PAGE = 1;
export const DESKTOP_SIZE = 12;

export const MOBILE_PAGE = 1;
export const MOBILE_SIZE = 6;
